const TICK_EVERY = 4; // frames between audible ticks

/** Counts the displayed credit balance up to a new value, so earnings roll in rather than appear. */
export class CreditTicker {
  private from = 0;
  private to = 0;
  private frame = 0;
  private duration = 0;
  private shown: number;

  constructor(value: number) {
    this.shown = value;
    this.to = value;
  }

  start(from: number, to: number, frames: number = 90): void {
    this.from = from;
    this.to = to;
    this.shown = from;
    this.frame = 0;
    this.duration = Math.max(1, frames);
  }

  /** Jumps straight to a balance, e.g. after spending credits. */
  set(value: number): void {
    this.from = this.to = this.shown = value;
    this.frame = this.duration = 0;
  }

  isRunning(): boolean {
    return this.frame < this.duration;
  }

  /** Advances one frame; `ticked` marks frames that should play a tick. */
  step(): { value: number; ticked: boolean } {
    if (!this.isRunning()) return { value: this.shown, ticked: false };

    this.frame++;
    const t = this.frame / this.duration;
    const eased = 1 - Math.pow(1 - t, 3);
    const previous = this.shown;
    this.shown = t >= 1 ? this.to : Math.round(this.from + (this.to - this.from) * eased);

    const ticked = this.shown !== previous && (this.frame % TICK_EVERY === 0 || t >= 1);
    return { value: this.shown, ticked };
  }
}
